export default {
    listener: () => {},
    proxyStore: true,
};
